<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" :head-bg="'#17a7ff'" :spin-show="spinShow" :head-blur="false" v-model="activeTab">
    <div slot="slogan">
      <div class="message-tab">
        <!-- <Button type="text" style="color:#eee">未读</Button> | <Button type="text" style="color:#eee">已读</Button> -->
      </div>
    </div>
    <div class="activity-item mgui-container message-list" slot="/message">
      <div v-if="messages.data.length>0">
        <Collapse v-model="currentMsg" @on-change="messageChange" :accordion="true">
          <Panel :name="''+item.id" v-for="(item, index) in messages.data" :key="index">
              <h6 style="width:100%;position:absolute;top:0;left:12px;" @click="read(item)">
                <div :style="{color:item.status==0?'#f00':'#999', marginRight: '20px', display:'inline-block'}"><Icon type="record"></Icon></div>{{item.title}}
              </h6>
              <div slot="content">
                  <div v-html="item.message"></div>
                  <div style="text-align:right">
                    <Button @click="$routeTo(item.url)" v-if="item.url" size="small">查看</Button>&nbsp;
                    <Button type="error" @click="del(item.id)" size="small">删除</Button>
                  </div>
              </div>
          </Panel>
        </Collapse>
        <div class="pager"><Page :total="messages.total" :page-size="messages.per_page"  @on-change="pagerChange"></Page></div>
      </div>
      <div v-else style="padding:20px;text-align:center;color:#999">-- 没有消息 --</div>
    </div>
  </content-layout>
</template>


<script>
  import {fetch, put, del} from '../fetch/api'

  export default {
    name: 'Message',
    data () {
      return {
        title: '消息',
        headImage: '/static/images/bg/message.png',
        tabs: [
          {'title': '消息中心', 'key': '/message', 'visible': true}
        ],
        spinShow: true,
        activeTab: '/message',
        currentMsg: [],
        messages: {
          data: []
        },
        params: {
          total: 0,
          page: 1
        }
      }
    },
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      messageChange () {
      },
      read (item) {
        if (item.status === 0) {
          item.status = 1
          put(`console/messageStatus/${item.id}?status=${item.status}`).then(() => {
            let num = this.$store.state.badge.message - 1
            this.$store.dispatch('setBadge', {key: 'message', 'value': num})
          })
        }
      },
      del (id) {
        this.$Modal.confirm({
          title: '删除消息',
          content: '确定删除该消息吗？',
          onOk: () => {
            del(`console/message/${id}`).then(res => {
              this.$Message.info(res.msg)
              this.fetchData()
            })
          }
        })
      },
      pagerChange (page) {
        this.params.page = page
        this.fetchData()
      },
      fetchData () {
        fetch(`console/message/0`, {params: this.params}).then(res => {
          if (res.status === 'ok') {
            this.messages = res.result
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      }
    }
  }
</script>

<style scoped>
  .message-tab{
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 10;
    background:rgba(255,255,255,.3);
    border-radius:4px;
    color: #ddd;
  }
  .message-list a{color:blue;}
</style>
